import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivity as GetActivityQuery,
    GetActivityVariables as GetActivityQueryVariables,
} from 'nutshell-graphql-types';

import GET_ACTIVITY from '../queries/get-activity.graphql';

export const useGetActivity = (activityId: string) => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetActivityQuery, GetActivityQueryVariables>(GET_ACTIVITY, {
        variables: {activityId},
        fetchPolicy: 'cache-and-network',
    });

    const activity = data ? data.activity : null;

    return {
        isLoading,
        activity,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
